import React from "react";
import { useTranslation } from "react-i18next";
import type { ThemeVariables, BankAccount } from "../../../types"; // Import BankAccount type

const BacsDetailsDisplay: React.FC = () => {
  const { t } = useTranslation();
  const bankAccounts = (window.themeVariables as ThemeVariables | undefined)
    ?.bankAccounts as BankAccount[] | undefined;

  return (
    <div className="bacs-details-section">
      <h3>{t("checkout.payment.bacs.title", "Direct Bank Transfer")}</h3>
      <p>
        {t(
          "checkout.payment.bacs.description",
          "Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account."
        )}
      </p>
      <div className="bank-account-details">
        <h4>{t("order.bankDetailsTitle", "Our Bank Details")}</h4>
        {bankAccounts && bankAccounts.length > 0 ? (
          <ul className="bank-accounts-list">
            {bankAccounts.map((account, index) => (
              <li key={index} className="bank-account-item">
                {account.account_name && (
                  <p>
                    <strong>
                      {t("order.bank.accountName", "Account Name")}:
                    </strong>{" "}
                    {account.account_name}
                  </p>
                )}
                {account.bank_name && (
                  <p>
                    <strong>{t("order.bank.bankName", "Bank Name")}:</strong>{" "}
                    {account.bank_name}
                  </p>
                )}
                {account.account_number && (
                  <p>
                    <strong>
                      {t("order.bank.accountNumber", "Account Number")}:
                    </strong>{" "}
                    {account.account_number}
                  </p>
                )}
                {account.iban && (
                  <p>
                    <strong>{t("order.bank.iban", "IBAN")}:</strong>{" "}
                    {account.iban}
                  </p>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p>
            {t(
              "order.bankDetailsUnavailable",
              "Bank account details are currently unavailable. Please contact us for assistance."
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default BacsDetailsDisplay;
